import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invite-banners',
  templateUrl: './invite-banners.component.html',
  styleUrls: ['./invite-banners.component.css']
})
export class InviteBannersComponent implements OnInit {
  userId = localStorage.getItem("currentUserId");

  constructor(private router: Router) { }

  ngOnInit() {
  }

  
  isLoggedIn() {
    if (!this.userId)
      this.router.navigate(['/auth'])
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/invite-banners/invite-banners.component.ts